<template>
  <div class="area-util">
    <el-cascader
      :disabled="able ? false : true"
      :style="`width:${width}`"
      v-model="value"
      :options="options"
      size="mini"
      :props="{
        children: 'c',
        value: 'n',
        label: 'n',
        multiple:multipleType
      }"
      :collapse-tags="multipleType"
      @change="handleChange"
      @focus="changeState"
      @blur="changeState">
    </el-cascader>
  </div>
</template>
<script>
import Area from '@/util/area'
export default {
  props: {
    form: {
      type: Object,
      required: true
    },
    k: {
      type: String,
      default: 'area'
    },
    state: {
      type: Object,
      default: () => {}
    },
    customize: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '470px'
    },
    province: {
      type: String,
      default: 'province'
    },
    city: {
      type: String,
      default: 'city'
    },
    district: {
      type: String,
      default: 'district'
    },
    able: {
      type: Boolean,
      default: true
    },
    multipleType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      value: [],
      options: Area
    }
  },
  created() {
    this.initValue()
  },
  methods: {
    handleChange(value) {
      if(this.multipleType) {
        this.form[this.k] = value
      }else{
        this.form[this.province] = value[0]
        this.form[this.city] = value[1]
        this.form[this.district] = value[2]
      }
      this.$emit('secondHandleArea')
    },
    changeState() {
      if(this.customize) this.$emit('stateCB',this.k)
    },
    initValue() {
      if(this.multipleType) {
        this.value = this.form[this.k]
      }else{
        const value = [
          this.form[this.province],
          this.form[this.city],
          this.form[this.district]
        ]
        this.value = value
      }
    }
  },
  watch: {
    form(nV) {
      this.initValue()
    }
  }
}
</script>
<style lang="scss">
.area-util {
  .el-input.is-disabled .el-input__inner {
    background: #fff;
    color: #606266 !important;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/Util/AreaUtil.vue